export default __webpack_public_path__ + "static/media/Hop.9280e838.svg";